import { pxToRem } from "../utils/index.js";
import { weights } from "../../components/Typography/Typography.styles.js";
const createFont = (fontSize, lineHeight, fontWeight, letterSpacing) => {
  return {
    fontSize,
    lineHeight,
    fontWeight: weights[fontWeight],
    letterSpacing
  };
};
const displayXl = createFont(pxToRem(48), "120%", "medium", "-0.01em");
const displayLg = createFont(pxToRem(36), "120%", "medium", "-0.01em");
const displayMd = createFont(pxToRem(28), "120%", "medium", "-0.01em");
const displaySm = createFont(pxToRem(20), "120%", "medium");
const displayXs = createFont(pxToRem(16), "140%", "bold");
const headingXl = createFont(pxToRem(40), "130%", "bold");
const headingLg = createFont(pxToRem(32), "130%", "bold");
const headingMd = createFont(pxToRem(24), "130%", "bold");
const headingSm = createFont(pxToRem(18), "130%", "bold");
const labelLg = createFont(pxToRem(18), "120%", "medium");
const labelMd = createFont(pxToRem(16), "120%", "medium");
const labelSm = createFont(pxToRem(14), "120%", "medium");
const labelButtonMd = createFont(pxToRem(18), "120%", "bold", "0.023em");
const labelButtonSm = createFont(pxToRem(14), "120%", "bold", "0.018em");
const labelOverline = createFont(pxToRem(14), "120%", "bold", "0.25em");
const bodyLg = createFont(pxToRem(18), "140%", "regular");
const bodyMd = createFont(pxToRem(16), "140%", "regular");
const bodySm = createFont(pxToRem(14), "140%", "regular");
const bodyXs = createFont(pxToRem(12), "140%", "regular");
export {
  bodyLg,
  bodyMd,
  bodySm,
  bodyXs,
  displayLg,
  displayMd,
  displaySm,
  displayXl,
  displayXs,
  headingLg,
  headingMd,
  headingSm,
  headingXl,
  labelButtonMd,
  labelButtonSm,
  labelLg,
  labelMd,
  labelOverline,
  labelSm
};
//# sourceMappingURL=index.js.map
